import script from "./AppRightContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./AppRightContainer.vue?vue&type=script&setup=true&lang=js"

import "./AppRightContainer.vue?vue&type=style&index=0&id=fab4f80e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fab4f80e"]])

export default __exports__